<template>
  <div class="Uncollected">
    <div class="page-title">{{title}}</div>
    <div>
      <ATable
        ref="table"
        v-loading="loading"        
        class="no-pointer"        
        :placeholder="placeHolder"
        :summaryTitleColumnIndex="2"
        :summaryFields="summaryFields"
        :search_field="search_field"
        :data="sortedItems"
        show-summary
        max-height="732px"  
        hide-button-insert
        hide-pagination
        border
        @sort-change="handleSortChange"
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector 
              ref="period" 
              :value="search_period" 
              hide-select
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.indexw"
        />
        <el-table-column 
          prop="name" 
          label="거래처명"
          width="120"
          show-overflow-tooltip 
          sortable="custom"
        />
        <el-table-column 
          prop="owner" 
          label="대표자" 
          :width="$width.username + 5" 
          show-overflow-tooltip 
          sortable="custom"
        />
        <el-table-column 
          prop="tel" 
          label="전화" 
          width="120" 
        />
        <el-table-column 
          prop="last_balance"
          label="이월금"
          class-name="cell-number"
          width="100"       
          sortable="custom"
          :formatter="util.numberFormat"   
        />
        <el-table-column 
          prop="sum_income"
          label="기간매출"
          class-name="cell-number"
          width="100" 
          sortable="custom"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="sum_expense"
          label="기간수금"
          class-name="cell-number"
          width="100" 
          sortable="custom"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="balance"
          label="잔액"
          class-name="cell-number"
          width="100" 
          sortable="custom"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="desc"
          label="비고"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="last_expense_date"
          label="최근수금"
          width="110"
          sortable="custom"
        />
        <el-table-column 
          prop="last_income_date"
          label="최근매출"
          width="110"
          sortable="custom"
        />
        <el-table-column 
          prop="recent_income"
          label="3개월간매출"
          class-name="cell-number"
          width="120" 
          sortable="custom"
          :formatter="util.numberFormat"
        />
      </ATable>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { sort_items } from "@/common/mixins/sort_items";

export default {
  name: "Uncollected",
  mixins: [sort_items],
  data() {
    return {
      title: this.$t('title.uncollected'),
      placeHolder: "거래처명, 사업장, 비고",
      search_field: ["name", "location", "desc"],
      summaryFields: ["last_balance", "sum_income", "sum_expense", "balance", "recent_income"],
      search_period: {value: '1w'},
      period: {},
      loading: false,
      items: [],
      i: 0,
    };
  },
  computed: {
    ...mapGetters(["table_customer"]),
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.statIncome(this.period).then(res => {        
        if (res.error !== this.system.noError) {
          this.loading = false;
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = this.organizeData(res.data);
        this.loading = false;
      });
    },
    organizeData(items) {
      items.forEach(item => {
        let c = this.table_customer.find(c => c.id === item.id);
        if (!c) { return true; }
        item.name = c.name;
        item.owner = c.owner;
        item.tel = c.tel;
      })
      return items;
    },
    handleChangePeriod(value) {
      this.period = value;
      this.handleClickSearch();
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    }, 
  },
};
</script>
